import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES_TITLES } from '@routes';

export const PageTitlesManager: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = ROUTES_TITLES[location.pathname] ?? ROUTES_TITLES.default;
  }, [location]);

  return null;
};
